var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 282 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000131364529179228932420000009134063357248385194_"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M252 238H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0h222c16.6 0 30 13.4 30 30v178c0 16.6-13.4 30-30 30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048484128720038876660000016964141891125649567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000048484128720038876660000016964141891125649567_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.3 177.9s-13.3-5.6-14.5-5.6-8.6 1-8.6 1-11.9-2.9-12.9-3.6c-1-.7-11.6-.8-12.4-.8s-8.7 2-10.4 2.2-8.2.7-8.9.2-5.9-1.2-7.4-.7-7.7.5-7.7.5-3-.5-4.5-1.5-4.7-2.2-6.2-2-3.2 3.2-5.9 3.5c-2.7.2-9.2.2-9.2.2s-7.7-2.5-10.4-1-8.9 3.7-10.4 4.5c-1.5.7-8.9.7-8.9.7s-4 .7-5 .2-5.2-2.7-5.9-3.2-3.5-1.5-4.7-1.7-5.9-2.7-5.9-2.7-3-1-3.7-1-8.4 0-9.7-.7c-1.2-.7-9.4-2.2-9.4-2.2s-3.2-2.5-3.7-3.2-4.2-2.7-4.2-2.7-5.7-1.7-6.4-2.5c-.7-.7-5-1.7-5-1.7l-4 3s-4.2 2.5-5.2 2.7-7.7-1.5-7.7-1.5l-2-2.2-3.2-.5-7.2 4-4.5 1-2.5 2.7-4.2 1.5-5.7 1.5-3 2.5-8.7.7-5.2 3-6.2 2-13.6 4.2v55.5l283.9 11.2.9-67.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.2 184.3l.3 1.7h-1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 184.3l-.4 1.7h1.5v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.1 175.5l-6.9 9.4 4.5-1.2 2.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.1 172.5l-5.8 7.9 3.8-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.1 170.4l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M243.1 175.5l6.8 9.4-4.5-1.1-2.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M243.1 172.5l5.7 7.9-3.7-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M243.1 170.4l4.3 5.9-2.8-.7-1.5.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-22.1 189.9l6.6-4.5s6.4.4 10.2 0c1.5-.2 4.1-.6 6.7-1.2l3.7 2.6 10.1.6 5.3 1.9L28 194l7.4 2.7 3.2 7.1 24.5-3.9 8.2-3.5 5.4 1.2 9.2-2 5.4 3.2 8.9 2 10.9 9.7 8.2 2.9 4.3-1.1 6.4-2.2 4.7-2.6 7.8-1.1 4.2-2.7c3.5-.5 7.4-1.6 8.3-2.2 1-.7 3.2-.7 3.2-.7s8.5-2 12.5-4.1 4.5-1.4 6.7-2c2.2-.7 3.9-5.6 4.4-6.3s7.5-4 9.3-4.4c1.7-.4 5-3.1 7-4s7.7.5 7.7.5 7.7.5 9.9.3 6-1.6 8-2 3-.7 4.2-.6c1.2 0 5.4.4 5.4.4s3.6 3.1 6.1 2.7c2.5-.4 10.3 3.8 15 5.6 4.7 1.9 7.7.5 7.7.5s4.2-.9 5.5-.6c1.2.3 7.1 3.4 8.3 3.7 1.2.3 6.6 1.9 8.1 2.2s6.9.4 8.9.5 3-2.4 4.8-2.6c1.7-.2 3.4 1.8 5.1 1.9 1.7 0 4.5.1 5.2.4.7.3 8.5 6.2 8.5 6.2l-2 72.3-342.6-9.7 1.9-67.8 4.1-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M354.3 241.6l-24.7-7.5-10.9.8-10.6-5.2-11.9-1.3-5.9-3.7h-4l-1-.2-1.7-2-5.3-2.6-7.5-.5-6.4 4.4-6.9 1.5-4.6 1.7-3.9-1.9-4.5 2.6-2.8 1.5-7.4.2-6.9-1.5-14.9 1.8-8.1 1.7-10.4-.5-9-3.7-8.6-3.2H165l-5-4-6.2-2.5-4.7-1.7-3.7-2.5-7.4-1.2-9.4-4.4-5.1.8-5.7-2.5h-6.7l-6.5 2.6-6.7.5-5.2-1.6-5.2 2.9-8.2 1.7h-.7l-4.1-3.1-4.5.6-5.6-3.9-8.9-3.7-4.8-1.9-9.5-1.9-4.5-2.7-6.2 2.1-10.8-2.7-7.5 1.4-6.2 2.9-9.9 2-2 1.7-9.4 5-2 4.7-6.6 2.5-4.5 2.7-4.2 3-5 3.2-7.4 6.2.1 49.7h399.5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150071184426249806380000000140343989852134022_",
    d: "M252 238H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0h222c16.6 0 30 13.4 30 30v178c0 16.6-13.4 30-30 30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149344655914174517050000007030233815684707774_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150071184426249806380000000140343989852134022_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000149344655914174517050000007030233815684707774_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M231.6 185.5l.4 1.7h-1.5v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4 185.5l-.3 1.7h1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.5 176.7l-6.8 9.4 4.4-1.2 2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.5 173.7l-5.8 7.8 3.8-.9 2 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.5 171.6l-4.3 5.9 2.8-.8 1.5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230.5 176.7l6.9 9.4-4.5-1.2-2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230.5 173.7l5.8 7.8-3.8-.9-2 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230.5 171.6l4.3 5.9-2.8-.8-1.5.7z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003081601855338942010000000273192997707859856_",
    d: "M252 238H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0h222c16.6 0 30 13.4 30 30v178c0 16.6-13.4 30-30 30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162329060676253222450000008354585258381210794_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003081601855338942010000000273192997707859856_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000162329060676253222450000008354585258381210794_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M258.4 193.5l.3 1.2h-1.1v-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.8 193.5l-.2 1.2h1v-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M257.6 187l-5 6.9 3.3-.8 1.7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M257.6 184.8l-4.2 5.8 2.8-.7 1.4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M257.6 183.2l-3.1 4.4 2-.6 1.1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.6 187l5.1 6.9-3.3-.8-1.8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.6 184.8l4.3 5.8-2.8-.7-1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.6 183.2l3.2 4.4-2.1-.6-1.1.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000048493139620776666570000001147427250312255156_",
    d: "M252 238H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0h222c16.6 0 30 13.4 30 30v178c0 16.6-13.4 30-30 30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166650832665175002340000008889637919222878628_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048493139620776666570000001147427250312255156_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000166650832665175002340000008889637919222878628_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.3 213.8l.4 1.7h-1.5v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1 213.8l-.3 1.7h1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.2 205l-6.8 9.4 4.5-1.1 2.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.2 202l-5.8 7.9 3.8-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.2 199.9l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.2 205l6.9 9.4-4.5-1.1-2.4 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.2 202l5.8 7.9-3.8-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.2 199.9l4.3 5.9-2.8-.7-1.5.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000155114139047202803890000002360698401131399611_",
    d: "M252 238H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0h222c16.6 0 30 13.4 30 30v178c0 16.6-13.4 30-30 30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073703178955881246190000002091681737218589850_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155114139047202803890000002360698401131399611_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000073703178955881246190000002091681737218589850_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.2 208.7l.5 2.4h-2.1v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1 208.7l-.5 2.4h2v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.6 196l-9.8 13.5 6.4-1.6 3.4 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.6 191.7L39.3 203l5.4-1.4 2.9 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.6 188.7l-6.2 8.5 4.1-1.1 2.1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.6 196l9.9 13.5-6.5-1.6-3.4 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.6 191.7l8.3 11.3-5.4-1.4-2.9 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.6 188.7l6.2 8.5-4-1.1-2.2 1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000047765788469665384040000001416516502712638864_",
    d: "M252 238H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0h222c16.6 0 30 13.4 30 30v178c0 16.6-13.4 30-30 30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061442683036853786090000003297421269637083046_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047765788469665384040000001416516502712638864_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000061442683036853786090000003297421269637083046_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.7 188.5l.5 2.4h-2.1v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 188.5l-.5 2.4h2.1v-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.1 175.8l-9.9 13.5 6.5-1.6 3.4 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.1 171.5l-8.3 11.3 5.4-1.4 2.9 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.1 168.5l-6.2 8.5 4.1-1.1 2.1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M199.1 175.8l9.9 13.5-6.5-1.6-3.4 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M199.1 171.5l8.3 11.3-5.4-1.4-2.9 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M199.1 168.5l6.2 8.5-4.1-1.1-2.1.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000150096864483918684450000007271070508535858324_",
    d: "M252 238H30c-16.6 0-30-13.4-30-30V30C0 13.4 13.4 0 30 0h222c16.6 0 30 13.4 30 30v178c0 16.6-13.4 30-30 30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093869718286020420490000004801749494061722021_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150096864483918684450000007271070508535858324_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000093869718286020420490000004801749494061722021_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.6 195.6l.4 1.7h-1.5v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4 195.6l-.3 1.7h1.4v-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.5 186.8l-6.8 9.4 4.5-1.2 2.3 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.5 183.8l-5.7 7.9 3.7-1 2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.5 181.7l-4.3 5.9 2.8-.7 1.5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M218.5 186.8l6.9 9.4-4.5-1.2-2.4 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M218.5 183.8l5.8 7.9-3.8-1-2 .9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M218.5 181.7l4.3 5.9-2.8-.7-1.5.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.2f635b199a1f498ffc98b3703bc6fa53.svg";
export { ForwardRef as ReactComponent };